import { SubscriptionRoutes } from "..";
import { format } from "date-fns";
import { FC, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { Button, Heading, SpacingToken, Text } from "@livechat/design-system-react-components";

import { DateFormat } from "constants/date";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { isInIframe } from "helpers/app";
import { formatPrice } from "helpers/subscription";
import { textEllipsisStylesWithWrap } from "styles/common";
import { withVar } from "themes/helpers";

import { ButtonsWrapper } from "../styled";

interface IProps {
  invoiceEmail: string;
  isTaxed: boolean;
  newPrice: number | null;
  nextInvoiceDate: Date | null;
}

export const FirstPayment: FC<IProps> = ({ invoiceEmail, isTaxed, newPrice, nextInvoiceDate }) => {
  const history = useHistory();
  const inIframe = isInIframe();

  useEffect(() => {
    trackEngagement("Subscription: Subscription is up and running page displayed", EventPlace.Subscription);
  }, []);

  return (
    <>
      <Heading size="lg" css={{ marginBottom: withVar(SpacingToken.Spacing4) }}>
        Your subscription is up and running!
      </Heading>
      <Text css={textEllipsisStylesWithWrap}>
        Your invoices will be sent to <b>{invoiceEmail}</b>.
        <br />
        The first one for{" "}
        <b>
          {newPrice && formatPrice(newPrice)}
          {isTaxed && " + applicable tax"}
        </b>{" "}
        {/* @ts-expect-error TS(2345) */}
        will be issued on <b>{format(nextInvoiceDate, DateFormat.DateWithoutDayOfTheWeek)}</b>.
      </Text>
      <ButtonsWrapper>
        {inIframe && (
          <Button kind="primary" onClick={() => history.push("/")}>
            Go to HelpDesk
          </Button>
        )}
        {!inIframe && (
          <Button kind="primary" onClick={() => history.push(SubscriptionRoutes.Plans)}>
            Go to my subscription
          </Button>
        )}
      </ButtonsWrapper>
    </>
  );
};
